import React, {useState} from 'react';
import {RotateLeft} from '@components/icon/RotateLeft';
import {PauseIcon} from '@components/icon/PauseIcon';
import {PlayIcon} from '@components/icon/PlayIcon';
import {RotateRight} from '@components/icon/RotateRight';
import IconButton from '@material-ui/core/IconButton';
import Loading from 'components/pure/utils/Loading';
import './PlayerControls.sass';
import {PlayerRef} from '@components/call-card/Player.utils';
import {VideoIcon} from '@components/icon/VideoIcon';
import Button from '@material-ui/core/Button';
import Tooltip from '@material-ui/core/Tooltip';
import {ChevronUpIcon} from '@components/icon/ChevronUpIcon';

interface PlayerControlsProps {
  playerRef: PlayerRef;
  videoHidden: boolean;
  showVideo: () => void;
}

const CALL_SPEEDS = [0.5, 0.75, 1, 1.25, 1.5, 1.75, 2, 4];
export const PlayerControls: React.FC<PlayerControlsProps> = ({
  playerRef,
  videoHidden,
  showVideo,
}) => {
  const [playbackRate, setPlaybackRate] = useState(1);
  if (!playerRef) {
    return <Loading />;
  }

  function changeCallSpeed(direction: 'up' | 'down') {
    if (!playerRef) return;
    const speedIndex = CALL_SPEEDS.findIndex(speed => speed === playerRef.playbackRate);
    const nextIndex =
      direction === 'up'
        ? Math.min(speedIndex + 1, CALL_SPEEDS.length - 1)
        : Math.max(speedIndex - 1, 0);
    playerRef.playbackRate = CALL_SPEEDS[nextIndex];
    setPlaybackRate(playerRef.playbackRate);
  }

  return (
    <div className="player-controls-wrapper">
      <div className="player-controls">
        {videoHidden && (
          <Button color="primary" className="show-video" onClick={showVideo}>
            <VideoIcon />
            <span>Show Video</span>
          </Button>
        )}
        <IconButton
          className="skip-button"
          size="small"
          onClick={() => (playerRef.currentTime -= 10)}>
          <RotateLeft tooltip="Rewind 10s" />
          <span className="skip-text">-10s</span>
        </IconButton>
        {playerRef.paused ? (
          <IconButton size="small" onClick={() => playerRef.play()}>
            <PlayIcon tooltip="Play" />
          </IconButton>
        ) : (
          <IconButton size="small" onClick={() => playerRef.pause()}>
            <PauseIcon tooltip="Pause" />
          </IconButton>
        )}
        <IconButton
          className="skip-button"
          size="small"
          onClick={() => (playerRef.currentTime += 30)}>
          <RotateRight tooltip="Skip 30s" />
          <span className="skip-text">+30s</span>
        </IconButton>
      </div>
      <div className="playback-rate-control">
        <IconButton size="small" onClick={() => changeCallSpeed('down')}>
          <ChevronUpIcon className="down" tooltip="Decrease playback speed" />
        </IconButton>
        <Tooltip title="Playback speed">
          <span className="playback-rate">{playbackRate}x</span>
        </Tooltip>
        <IconButton size="small" onClick={() => changeCallSpeed('up')}>
          <ChevronUpIcon tooltip="Increase playback speed" />
        </IconButton>
      </div>
    </div>
  );
};
